import { enGB } from 'date-fns/locale';
export var LOCAL_STORAGE_SETTINGS_KEY = 'chatgpt-ui-settings';
export var VALID_LOCALES = ['en-GB', 'en-US'];
export var DEFAULT_LOCALE = enGB;
export var DEFAULT_LOCALE_CODE = DEFAULT_LOCALE.code || 'en-GB';
export var ADMIN_ROLE = 'ChatUI_Admin';
export var POWER_USER_ROLE = 'ChatUI_PowerUser';
export var DEFAULT_API = 'chatgpt';
// must be aligned with backend limits
export var MAX_SIMULTANEOUS_FILE_UPLOADS = 50;
